import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatImage, formatUrl } from '@ifeng-fe/public_method';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classnames } from '../../../utils/classnames';

class NewsStream extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    // 格式化时间
    formatTime(time) {
        return time.split(' ')[0];
    }
    listItemView(list = []) {
        return list.map((item, index) => {
            const { source, newsTime, title, url, thumbnails } = item;
            const image =
                thumbnails &&
                thumbnails !== '' &&
                thumbnails.image &&
                thumbnails.image.value &&
                thumbnails.image.value[0] &&
                thumbnails.image.value[0].url
                    ? thumbnails.image.value[0].url
                    : null;
            const furl = formatUrl(url);

            return (
                <li key={index} className={styles.item}>
                    <h2 className={styles.title}>
                        <a href={furl} title={title} target="_blank" rel={relText}>
                            {title}
                        </a>
                    </h2>
                    <div className="clearfix">
                        <a className={styles.imgLink} href={furl} target="_blank" rel={relText}>
                            <img src={formatImage(image, 188, 118)} alt={title} width={188} height={118} />
                        </a>
                        <div className={styles.textBox}>
                            <p className={styles.summary}>{item.summary}</p>
                            <p className={styles.etc}>
                                {source ? <span className={styles.mr5}>作者：{source}</span> : null}
                                {newsTime ? <span>时间：{this.formatTime(newsTime)}</span> : null}
                            </p>
                        </div>
                    </div>
                </li>
            );
        });
    }
    render() {
        const { newsstream, page, endPage, columnId } = this.props.content;
        /* eslint-disable */
        const url = `${pitUrl}/shanklist/pit/${columnId}/`;
        /* eslint-enable */

        return [
            <div key="newsstream" className={styles.box}>
                <ul className={styles.list}>{this.listItemView(newsstream)}</ul>
                <div className={classnames(styles.nextbox, 'clearfix')}>
                    {page <= 1 ? null : (
                        <a className={classnames(styles.nextpage, styles.mr25)} href={`${url}${page - 1}`}>
                            上一页
                        </a>
                    )}
                    {page >= endPage ? null : (
                        <a className={styles.nextpage} href={`${url}${page + 1}`}>
                            下一页
                        </a>
                    )}
                </div>
            </div>,
            <div key="line" className={styles.line} />,
        ];
    }
}

export default NewsStream;
